import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: { retry: 0 },
  },
});

export function makeRouter(authPlaceholder: import("./lib/auth").AuthSnapshot) {
  return createRouter({
    routeTree,
    context: { queryClient, auth: authPlaceholder },
    defaultPreload: "intent",
    defaultPendingMs: 300,
    defaultPendingMinMs: 500,
  });
}

export type AppRouter = ReturnType<typeof makeRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
